import { styled, theme } from "@theme/stitches.config"
import { Container } from "@components/styles"
import FormMessage from "@components/FormMessage"

export const NewsLetterSignUpWrapper = styled("div", {
    py: 120,
    backgroundColor: theme.colors.N900,
    "@mdDown": {
        py: 60
    }
})

export const InnerWrapper = styled(Container, {
    padding: "35px 50px",
    backgroundColor: "#454F66",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    "@mdDown": {
        flexDirection: "column",
        padding: "35px 30px",
        justifyContent: "center"
    },
    [`${FormMessage}`]: {
        flex: "1 0 100%",
        maxWidth: "100%"
    }
})

export const TextWrapper = styled("div", {
    mr: 10,
    "@mdDown": {
        mr: 0
    }
})

export const Title = styled("p", {
    fontSizePxToRem: 24,
    fontFamily: theme.fonts.heading,
    textTransform: "uppercase"
})

export const Subtitle = styled("p", {
    mt: 12
})

export const ActionWrapper = styled("form", {
    display: "flex",
    flexWrap: "wrap",
    margin: -10,
    "& :first-child": {
        width: 270
    },
    "& input": {
        height: 52
    },
    "& > *": {
        height: 52,
        whiteSpace: "nowrap",
        margin: 10
    },
    "@mdDown": {
        mt: 20,
        flexDirection: "column",
        width: "100%",
        "& > *": {
            width: "100%",
            margin: "10px 0"
        },
        "& :first-child": {
            width: "100%"
        }
    }
})
